// extracted by mini-css-extract-plugin
export default {"card_mylearning":"CardMyLearning_card_mylearning__FazmW"};